import { AI_AGENTS_MONITORING_ITEM_ID, AI_BUILDER_MENU_ITEM_ID } from "features/settings/constants";

export const WINDOW_MARGIN_PX = 200;
export const TAB_MARGIN_PX = 20;


export const CONDITIONAL_TAB_ITEMS = {
    [AI_BUILDER_MENU_ITEM_ID]: ['isAiAgentEnabled'],
    [AI_AGENTS_MONITORING_ITEM_ID]: ['isAiAgentEnabled', 'isAiAgentsMonitoringScreenEnabled']
  };